import { useSelector } from "react-redux";
import { hasAccess } from "../../helpers/hierarchy"
import { get, isString } from "lodash";
import Forbidden from "../../components/Materials/Forbidden";

const WithPermission = ({ permission, showForbidden = false, children }) => {
    const storage = useSelector((state) => get(state, 'storage', {}));

    const hasPermission = Array.isArray(permission) ? permission.some((perm) => hasAccess(storage, perm)) : isString(permission) && hasAccess(storage, permission);

    if (hasPermission === true) {
        return (<>{children}</>);
    }
    if (showForbidden === true) {
        return (<><Forbidden status={403} /></>);
    }
    return null;
};

export default WithPermission;
